export default "__VITE_ASSET__42f781d3__"